import React, { type FunctionComponent } from 'react';

import type { Features } from '../../features';

export const FeaturesContext = React.createContext<Partial<Features>>({});

interface Props {
  features: Partial<Features>;
  children?: React.ReactNode;
}

export const FeatureFlagProvider: FunctionComponent<Props> = ({
  children,
  features,
}) => (
  <FeaturesContext.Provider value={features}>
    {children}
  </FeaturesContext.Provider>
);
